import type { ComponentProps } from 'react'
import type { LucideIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function ExpandingIconButton({
  icon: Icon,
  label,
  ...props
}: Omit<ComponentProps<typeof Button>, 'children' | 'aria-label'> & {
  icon: LucideIcon
  label: string
}) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="group/btn h-9 w-auto min-w-9 gap-0 overflow-hidden p-0 text-muted-foreground hover:text-muted-foreground focus-visible:text-muted-foreground"
      aria-label={label}
      {...props}
    >
      <span className="flex size-8 shrink-0 items-center justify-center" aria-hidden="true">
        <Icon className="size-3.5" strokeWidth={1.5} />
      </span>
      <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-150 group-hover/btn:max-w-24 group-hover/btn:pr-2 group-hover/btn:opacity-100 group-focus-visible/btn:max-w-24 group-focus-visible/btn:pr-2 group-focus-visible/btn:opacity-100">
        {label}
      </span>
    </Button>
  )
}
